// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__zcp6t","right":"Footer_right__2lGqc","buttons":"Footer_buttons__1-MP7"};